import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://app.agendali.com.br/api',
  withCredentials: true,
  timeout: 15000, // 15s — evita loading infinito quando conexão cai
});

let token: string | null = localStorage.getItem('token');

api.interceptors.request.use((config) => {
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    if (error.response?.status === 401 && !error.config._retry) {
      error.config._retry = true;
      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_API_URL || 'https://app.agendali.com.br/api'}/auth/refresh`,
          {}, { withCredentials: true }
        );
        token = data.token;
        localStorage.setItem('token', data.token);
        error.config.headers.Authorization = `Bearer ${token}`;
        return api(error.config);
      } catch {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const setToken = (t: string) => {
  token = t;
  localStorage.setItem('token', t);
};

export const clearToken = () => {
  token = null;
  localStorage.removeItem('token');
};

export default api;
